import React, { useEffect, useState } from "react";
import "./SavvyLoader.css";

function SavvyLoader({ onDone }) {
    const [exiting, setExiting] = useState(false);

    useEffect(() => {
        const fadeTimer = setTimeout(() => setExiting(true), 2100);
        const doneTimer = setTimeout(onDone, 2600);
        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(doneTimer);
        };
    }, [onDone]);

    return (
        <div className={`savvy-loader-overlay${exiting ? " savvy-loader-exiting" : ""}`}>
            <div className="savvy-loader-smoke savvy-loader-smoke-a" />
            <div className="savvy-loader-smoke savvy-loader-smoke-b" />
            <div className="savvy-loader-face">
                <div className="savvy-loader-eyes">
                    <div className="savvy-loader-eye">V</div>
                    <div className="savvy-loader-eye">V</div>
                </div>
            </div>
        </div>
    );
}

export default SavvyLoader;
